import { useCallback, useState } from 'react'

/**
 * @param {{ activeThreadId?: string | null, onSendEditVersion?: (p: { threadId: string, exchangeId: string, text: string }) => void }} options
 */
export function useChatThreadEdit({ activeThreadId = null, onSendEditVersion }) {
  const [editingExchangeId, setEditingExchangeId] = useState(/** @type {null | string} */(null))
  const [draftByExchangeId, setDraftByExchangeId] = useState(/** @type {Record<string, string>} */({}))

  const startEdit = useCallback((msg) => {
    const exId = msg.exchangeId ?? msg.id
    setEditingExchangeId(exId)
    setDraftByExchangeId((prev) => ({ ...prev, [exId]: prev[exId] ?? msg.text }))
  }, [])

  const cancelEdit = useCallback((exchangeId) => {
    setEditingExchangeId((prev) => (prev === exchangeId ? null : prev))
  }, [])

  const sendEdit = useCallback(
    (exchangeId) => {
      if (!activeThreadId) return
      const text = draftByExchangeId[exchangeId] ?? ''
      onSendEditVersion?.({ threadId: activeThreadId, exchangeId, text })
      setEditingExchangeId((prev) => (prev === exchangeId ? null : prev))
    },
    [activeThreadId, draftByExchangeId, onSendEditVersion],
  )

  return {
    editingExchangeId,
    draftByExchangeId,
    setDraftByExchangeId,
    startEdit,
    cancelEdit,
    sendEdit,
  }
}
